import { citiesApi } from '@features/cities/api/citiesApi'
import { useCityGeolocation } from '@features/cities/composables/useCityGeolocation'
import {
  formatCitiesList,
  getCountryNameByTld,
} from '@features/cities/services/formatCitiesList'
import type { City } from '@features/cities/types'
import { getCountryDomain } from '@shared/lib/getCountryDomain'

/**
 * Загружает и форматирует список городов для блока выбора города.
 *
 * @returns реактивное состояние поиска, списка и геолокации
 */
export const useCitiesBlock = async () => {
  const { $host } = useNuxtApp()
  const mode = useRuntimeConfig().public.MODE
  const searchQuery = ref('')
  const isInputCityFocused = ref(false)
  const cities = ref<City[]>([])
  const countryName = getCountryNameByTld(getCountryDomain($host, mode))

  const formattedCitiesList = computed(() =>
    formatCitiesList({
      cities: cities.value,
      countryName,
      searchQuery: searchQuery.value,
    }),
  )

  const { detectedCity, isGeoLoading } = useCityGeolocation(formattedCitiesList)

  const { data, error } = await citiesApi.getList()

  if (error.value) {
    throw new Error(`Ошибка при получении списка городов: ${error.value}`)
  }

  cities.value = data.value ?? []

  return {
    searchQuery,
    isInputCityFocused,
    formattedCitiesList,
    detectedCity,
    isGeoLoading,
  }
}
